export const TEST_ID = 'mapPinIcon';
